import React, { useState } from 'react';
function SharedGPA5to100() {
    const [originalGPA, setOriginalGPA] = useState('');
    const [convertedGrade, setConvertedGrade] = useState('');
    const [showResult, setShowResult] = useState(false);
    const [error, setError] = useState(null);
    const handleCalculateClick = () => {
        const gpa = parseFloat(originalGPA);
        if (!isNaN(gpa) && gpa >= 0 && gpa <= 5.0) {
            let calculatedGrade = '';
            if (gpa >= 5.00) {
                calculatedGrade = 100;
            } else if (gpa >= 4.95) {
                calculatedGrade = 99;
            } else if (gpa >= 4.90) {
                calculatedGrade = 98;
            } else if (gpa >= 4.84) {
                calculatedGrade = 97;
            } else if (gpa >= 4.79) {
                calculatedGrade = 96;
            } else if (gpa >= 4.73) {
                calculatedGrade = 95;
            } else if (gpa >= 4.68) {
                calculatedGrade = 94;
            } else if (gpa >= 4.62) {
                calculatedGrade = 93;
            } else if (gpa >= 4.57) {
                calculatedGrade = 92;
            } else if (gpa >= 4.51) {
                calculatedGrade = 91;
            } else if (gpa >= 4.45) {
                calculatedGrade = 90;
            } else if (gpa >= 4.34) {
                calculatedGrade = 89;
            } else if (gpa >= 4.23) {
                calculatedGrade = 88;
            } else if (gpa >= 4.12) {
                calculatedGrade = 87;
            } else if (gpa >= 4.01) {
                calculatedGrade = 86;
            } else if (gpa >= 3.90) {
                calculatedGrade = 85;
            } else if (gpa >= 3.79) {
                calculatedGrade = 84;
            } else if (gpa >= 3.68) {
                calculatedGrade = 83;
            } else if (gpa >= 3.57) {
                calculatedGrade = 82;
            } else if (gpa >= 3.45) {
                calculatedGrade = 81;
            } else if (gpa >= 3.34) {
                calculatedGrade = 80;
            } else if (gpa >= 3.23) {
                calculatedGrade = 79;
            } else if (gpa >= 3.12) {
                calculatedGrade = 78;
            } else if (gpa >= 3.01) {
                calculatedGrade = 77;
            } else if (gpa >= 2.90) {
                calculatedGrade = 76;
            } else if (gpa >= 2.79) {
                calculatedGrade = 75;
            } else if (gpa >= 2.68) {
                calculatedGrade = 74;
            } else if (gpa >= 2.57) {
                calculatedGrade = 73;
            } else if (gpa >= 2.46) {
                calculatedGrade = 72;
            } else if (gpa >= 2.35) {
                calculatedGrade = 71;
            } else if (gpa >= 2.24) {
                calculatedGrade = 70;
            } else if (gpa >= 2.13) {
                calculatedGrade = 69;
            } else if (gpa >= 2.02) {
                calculatedGrade = 68;
            } else if (gpa >= 1.92) {
                calculatedGrade = 67;
            } else if (gpa >= 1.82) {
                calculatedGrade = 66;
            } else if (gpa >= 1.71) {
                calculatedGrade = 65;
            } else if (gpa >= 1.60) {
                calculatedGrade = 64;
            } else if (gpa >= 1.50) {
                calculatedGrade = 63;
            } else if (gpa >= 1.40) {
                calculatedGrade = 62;
            } else if (gpa >= 1.31) {
                calculatedGrade = 61;
            } else if (gpa >= 1.21) {
                calculatedGrade = 60;
            } else {
                calculatedGrade = 'Fail';
            }
            setConvertedGrade(calculatedGrade);
            setShowResult(true);
            setError(null);
        } else {
            setError('Enter a valid value between 0 and 5.0');
            setShowResult(false);
        }
    };
    return (
        <div>
            <div className="row">
                <div className="col-sm-12 col-md-7 calculatorStyle">
                    <div className="p-3 mb-2 bg-success text-white">
                        <h2 style={{ fontSize: '16px' }}>Convert 5.0-Point GPA to 100-Point Scale</h2>
                    </div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                        <b><label htmlFor='originalGPA'>GPA (out of 5.0):</label></b>
                        <input
                            type="text"
                            value={originalGPA}
                            id="originalGPA"
                            onChange={(e) => setOriginalGPA(e.target.value)}
                            className='form-control'
                            style={{ width: '200px', marginRight: '4px' }}
                        />
                    </div>
                    <button className="btn btn-success mt-3" onClick={handleCalculateClick}>
                        Calculate
                    </button>
                    <br />
                </div>
            </div>
            <br />
            <div className="row">
                <div className="col-sm-12 col-md-7">
                    {error && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly. </div>}
                    {showResult && (
                        <div style={{ fontSize: '17px' }} className=" bg-light bg-gradient text-dark">
                            <div className="p-3 bg-success bg-gradient text-white">
                                <strong>Results:</strong>
                            </div>
                            <b>Grade (out of 100): {convertedGrade}</b>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default SharedGPA5to100;
